var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5579 9.55806C9.31382 9.80214 9.31382 10.1979 9.5579 10.4419L12.0579 12.9419C12.302 13.186 12.6977 13.186 12.9418 12.9419C13.1859 12.6979 13.1859 12.3021 12.9418 12.0581L11.5087 10.625H15.8332C16.1783 10.625 16.4582 10.3452 16.4582 10C16.4582 9.65482 16.1783 9.375 15.8332 9.375H11.5087L12.9418 7.94194C13.1859 7.69786 13.1859 7.30214 12.9418 7.05806C12.6977 6.81398 12.302 6.81398 12.0579 7.05806L9.5579 9.55806Z",
    fill: "#AFAEBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83317 3.125C5.25787 3.125 4.7915 3.59137 4.7915 4.16667V15.8333C4.7915 16.4086 5.25787 16.875 5.83317 16.875H14.1665C14.7418 16.875 15.2082 16.4086 15.2082 15.8333V15C15.2082 14.6548 15.488 14.375 15.8332 14.375C16.1783 14.375 16.4582 14.6548 16.4582 15V15.8333C16.4582 17.099 15.4322 18.125 14.1665 18.125H5.83317C4.56752 18.125 3.5415 17.099 3.5415 15.8333V4.16667C3.5415 2.90101 4.56752 1.875 5.83317 1.875H14.1665C15.4322 1.875 16.4582 2.90101 16.4582 4.16667V5C16.4582 5.34518 16.1783 5.625 15.8332 5.625C15.488 5.625 15.2082 5.34518 15.2082 5V4.16667C15.2082 3.59137 14.7418 3.125 14.1665 3.125H5.83317Z",
    fill: "#AFAEBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogIn);
export default __webpack_public_path__ + "static/media/log-in.c0cd3f48181dc1f42b182c8ca5bed72b.svg";
export { ForwardRef as ReactComponent };